export default "__VITE_ASSET__DKJLThji__"